import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryVisitQuestions: BlogMetaData = {
  title: '保育園見学で聞くこと一覧｜後悔しない質問リストと聞き方のコツ（保存版）',
  description:
    '保育園見学で必ず聞くこと・確認ポイントをカテゴリ別に網羅。安全・教育方針・給食・料金など7分野の質問リストに加え、見学前3分でできる準備とOK/NGの聞き方まで解説する保存版ガイド。',
  thumbnailUrl: '/img/first-view-image6.webp',
  filePath: buildBlogFilePath('nursery-visit-questions'),
  category: BLOG_CATEGORY.NURSERY,
};
